<template>
  <div>
    <div>
      <vs-tabs class="bg_filled_tab_holder" v-model="tabIndex">
        <vs-tab label="Email">
          <div
            style="height: 128px; overflow: auto"
            class="vertical_scrollbar"
            @scroll="detectsScrollLength()"
            ref="element"
          >
            <div
              class="
                flex
                justify-between
                items-center
                border_btm
                quick_msg_data
                py-4
              "
              v-for="(item, index) in EmailSentData"
              :key="index"
            >
              <div class="inline-flex items-center w-full">
                <!-- <vs-checkbox /> -->
                <span class="material-icons-outlined icon">email</span>
                <p class="title_holder">{{ item.subject }}</p>
              </div>
            </div>
          </div>

          <vs-button icon="add" class="mt-4" @click="addEmailPopup = true"
            >Add New</vs-button
          >
        </vs-tab>
        <vs-tab label="SMS">
          <div style="height: 128px; overflow: auto" class="vertical_scrollbar"  @scroll="detectsScrollLengthSMS()"
            ref="element">
            <div
              class="
                flex
                justify-between
                items-center
                border_btm
                quick_msg_data
                py-4
              "
              v-for="(item, index) in smsLogs" :key="index"
            >
              <div class="inline-flex items-center w-full">
                <!-- <vs-checkbox /> -->
                <span class="material-icons-outlined icon">sms</span>
                <p class="title_holder">{{item.body}}</p>
              </div>
            </div>
          </div>

          <vs-button icon="add" class="mt-4" @click="addSMSPopup = true"
            >Add New</vs-button
          >
        </vs-tab>
        <vs-tab label="Chat">
          <div style="height: 128px; overflow: auto" class="vertical_scrollbar">
            <div
              class="
                flex
                justify-between
                items-center
                border_btm
                quick_msg_data
                py-4
              "
              v-for="(item, index) in chatLogs" :key="index"
            >
              <div class="inline-flex items-center w-full">
                <!-- <vs-checkbox /> -->
                <span class="material-icons-outlined icon">sms</span>
                <p class="title_holder">{{item.message}}</p>
              </div>
            </div>
          </div>

          <vs-button icon="add" class="mt-4" @click="chatPopup = true"
            >Add New</vs-button
          >
        </vs-tab>
      </vs-tabs>
    </div>
    <!-- add email modal -->
    <div v-if="addEmailPopup">
      <ComposeEmailPopup
        :newComposeEmail="addEmailPopup"
        @closeComposeEmailPopup="closeComposeEmailPopup"
      />
    </div>

    <!-- add sms modal -->
   <div v-if="addSMSPopup">
    <ComposeSmsPopup  :addSMSPopup="addSMSPopup" @closeSmsPopup="closeSmsPopup" />
  </div>

    <!-- chat modal -->
    <div
      class="
        vs-component
        con-vs-popup
        vs-popup-primary
        cstm-modal-popup
        quick_chat_popup
      "
      v-if="chatPopup"
      :class="{ show: chatPopup }"
    >
      <div class="cstm-modal">
        <div class="header">
          <h4>Quick Chat</h4>
          <button @click.stop="chatPopup = false" class="close-modal">
            &times;
          </button>
        </div>
        <div
          style="height: auto; max-height: calc(100vh - 100px)"
          class="modal-content"
        >
          <Chat @chatSent="chatSent" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import {EventBus} from '@/views/pages/messaging/mixin/EventBus.js'

import ComposeEmailPopup from '@/views/pages/email/composeEmailPopup.vue'
import Chat from '@/views/pages/messaging/index.vue'
import ComposeSmsPopup from '@/views/pages/sms/composeSmsPopup.vue'


import { getEmailSentList, fetchSMSLog, fetchChatLog } from '@/api/communication'

export default {
  data () {
    return {
      smsLogs: [],
      chatLogs: [],
      addEmailPopup: false,
      addSMSPopup: false,
      chatPopup: false,
      query_page: {
        total: '',
        limit: 10,
        has_next: false,
        current_page: 1,
        next_page_url: null,
        previous_page_url: ''
      },
      query_page_sms: {
        total: '',
        limit: 10,
        has_next: false,
        current_page: 1,
        next_page_url: null,
        previous_page_url: ''
      },
      EmailSentData: [],
      tabIndex: 0,
      customer_id: localStorage.getItem('customer_id')
    }
  },
  mixins:[EventBus],
  components: {
    ComposeEmailPopup,
    Chat,
    ComposeSmsPopup
  },
  mounted () {
    this.getSentList()

    EventBus.$on('chatSentEvent', (data) => {
      
      this.chatPopup = false
      this.fetchChatLog()

      
    })
  },
  watch:{
    tabIndex () {
      console.log(this.tabIndex)
      if (this.tabIndex === 0) {
        this.getSentList()
      } else  if (this.tabIndex === 1) {
        this.fetchSmsLog()
      } else  if (this.tabIndex === 2) {
        this.fetchChatLog()
      }
    }
  },
  methods: {
    async chatSent () {
      console.log("hii")
    },
    async fetchChatLog (page = 1) {
      try {
        console.log('hii')
        const res = await fetchChatLog(this.customer_id)
        this.chatLogs = res.data.data.recent_chat_data
        this.query_page_sms = res.data.data.meta

      } catch (error) {
        console.warn(error)
      }
    },
    async fetchSmsLog (page = 1) {
      try {
        const res = await fetchSMSLog(localStorage.getItem('customer_id'), this.query_page_sms.current_page)
        this.smsLogs = res.data.data.sms
        this.query_page_sms = res.data.data.meta

      } catch (error) {
        console.warn(error)
      }
    },
    async loadMoreSms () {
      this.query_page_sms.current_page = this.query_page_sms.current_page + 1
      const {data } = await fetchSMSLog(localStorage.getItem('customer_id'), this.query_page_sms.current_page)
      this.smsLogs.push(...data.data.sms)
      this.query_page_sms = data.data.meta
    },
    detectsScrollLengthSMS () {
      console.log('hii', this.query_page_sms)
      if (
        Math.ceil(
          this.$refs.element.scrollTop + this.$refs.element.offsetHeight
        ) >= this.$refs.element.scrollHeight && this.query_page_sms.has_next
      ) {
        this.loadMoreSms()
      }
    }, 
    detectsScrollLength () {
      if (
        Math.ceil(
          this.$refs.element.scrollTop + this.$refs.element.offsetHeight
        ) >= this.$refs.element.scrollHeight && this.query_page.has_next
      ) {
        this.loadMoreEmail()
      }
    },
    async loadMoreEmail () {
      const payload = {}
      this.query_page.current_page = this.query_page.current_page + 1
      const {data } = await getEmailSentList({},
        'email_sent',
        payload,
        this.customer_id,
        this.query_page.current_page,
        10)
      this.EmailSentData.push(...data.data.emails)
      this.query_page = data.data.meta
    },
    closeComposeEmailPopup () {
      this.addEmailPopup = false
      this.getSentList()
    },
    closeSmsPopup () {
      this.addSMSPopup = false
      this.fetchSmsLog()
    },
    async getSentList () {
      
      const payload = {}
      const data = await getEmailSentList(
        {},
        'email_sent',
        payload,
        this.customer_id,
        this.query_page.current_page,
        10
      )
      //
      this.EmailSentData = data.data.data.emails
      this.query_page = data.data.data.meta
    }
  }
}
</script> 